import { Button, Flex } from "antd";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import Logo from "../../../../assets/images/logo.svg";
import { eIdUrl } from "../../../../config";
import style from "./LoginButton.module.scss";

const LoginButton = () => {
  const navigate = useNavigate();

  const loginHandler = (e: any) => {
    if (process.env.NODE_ENV === "development")
      return navigate("/LogInSuccess");
    return (window.location.href = eIdUrl);
  };

  return (
    <Button type="primary" onClick={loginHandler} className={style.loginBtn}>
      <Flex align="center">
        <Flex
          align="center"
          justify="center"
          className={style.loginButtonImgWrapper}
        >
          <img src={Logo} alt="eid-logo" />
        </Flex>

        <Flex flex={1} justify="center" align="center">
          <span className={style.fontSize}>{`${t(
            "LOGIN.PRIJAVA_PREKO_PORTALA"
          )} eid.gov.rs`}</span>
        </Flex>
      </Flex>
    </Button>
  );
};

export default LoginButton;
